import { useLoad } from '@gogame/query';

import { loadReasons } from '../sources/fields';
import { reasons } from './queryKeyFactory';

export const useLoadReasons = () => {
  return useLoad(reasons(), loadReasons);
};
